<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ title }}</h3>
		<div class="flex flex-wrap text-sm">
			<span v-for="(tech, index) in data" :key="index">
				{{ tech.name[locale] }}
				<span v-if="index != data.length - 1" class="mx-2">|</span>
			</span>
		</div>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

type tData = {
	name: {
		en: string;
		hu: string;
		ro: string;
	};
};

export default defineComponent({
	name: "DjBoxTechnology",
	props: {
		title: {
			type: String,
			default: "title",
		},
		data: {
			type: Array as PropType<tData[]>,
			required: true,
		},
		locale: {
			type: String,
			default: "hu",
		},
	},
});
</script>
